import styled from "@emotion/styled";
import { Button, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useWindowSize } from "utils";
import { getLinkParams } from "auth-provider";

export const ThemeText = styled.div<{
  fontSize?: number;
  fontColor?: string;
  fontWieght?: number;
}>`
  font-size: ${(props) => (props.fontSize ? props.fontSize + "rem" : "1.6rem")};
  line-height: normal;
  color: ${(props) => (props.fontColor ? props.fontColor : "#EDD6B4")};
  font-weight: ${(props) => (props.fontWieght ? props.fontWieght : undefined)};
`;

export const DisplayText = styled.div<{
  dir?: string;
  aliItem?: string;
  justCon?: string;
  marginVal?: string;
}>`
  display: flex;
  flex-direction: ${(props) => (props.dir ? props.dir : "row")};
  align-items: ${(props) => (props.aliItem ? props.aliItem : "center")};
  justify-content: ${(props) => (props.justCon ? props.justCon : "center")};
  margin: ${(props) => (props.marginVal ? props.marginVal : undefined)};
`;

export const PicContent = styled.div<{
  url: string;
  height?: number;
  width?: number;
}>`
  height: ${(props) => (props.height ? props.height + "rem" : undefined)};
  width: ${(props) => (props.width ? props.width + "rem" : undefined)};
  background: ${(props) => `url(${props.url}) no-repeat center`};
`;

export const PicContentImg = styled.img<{
  height?: number;
  width?: number;
}>`
  height: ${(props) => (props.height ? props.height + "rem" : "100%")};
  width: ${(props) => (props.width ? props.width + "rem" : "100%")};
  object-fit: cover;
`;

export const Rectangle = styled.div<{
  width: number;
  height?: number;
  background?: string;
}>`
  width: ${(props) => props.width + "rem"};
  height: ${(props) =>
    props.height ? props.height + "rem" : props.width + "rem"};
  background: ${(props) => (props.background ? props.background : "#ffffff")};
`;

// 将公共样式提取出来，放在公共组件Row中
// props中可能包含的属性，都应该在泛型中定义
export const Row = styled.div<{
  gap?: number | boolean;
  between?: Boolean;
  marginBottom?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.between ? "space-between" : undefined)};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom + "rem" : undefined};
  > * {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    margin-right: ${(props) =>
    typeof props.gap === "number"
      ? props.gap + "rem"
      : props.gap
        ? "2rem"
        : undefined};
  }
`;

const FullPage = styled.div<{
  isKiosk?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props.isKiosk ? "#fff" : undefined)};
`;

export const FullPageLoading = () => {
  const { height: currentHeight } = useWindowSize();
  const antIcon = <LoadingOutlined style={{ fontSize: "3.6rem" }} spin />;

  const { orderSource = "" } = getLinkParams();
  const isKiosk =
    window.location.pathname === "/notify" && orderSource === "kiosk";
  return (
    <FullPage isKiosk={isKiosk} style={{ height: currentHeight + "px" }}>
      <Spin indicator={antIcon} size={"large"}></Spin>
    </FullPage>
  );
};

export const FullPageErrorFallback = ({ error }: { error: Error | null }) => (
  <FullPage>
    <Typography.Text type={"danger"}>{error?.message}</Typography.Text>
  </FullPage>
);

// 类型守卫
const isError = (value: any): value is Error => value?.message;

export const ErrorBox = ({ error }: { error: unknown }) => {
  if (isError(error)) {
    return <Typography.Text type={"danger"}>{error?.message}</Typography.Text>;
  }
  // 必不可少，否则ErrorBox不能作为jsx element用
  return null;
};

export const NormalButton = styled(Button) <{
  width?: number | boolean;
  background?: string;
  fontWeight?: number | null;
}>`
  width: ${(props) => (props.width ? props.width + "rem" : "32.7rem")};
  height: 4rem;
  background: ${(props) => (props.background ? props.background : "#e00051")};
  border-radius: 2.2rem;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  font-size: 1.8rem;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "normal")};
`;

export const ButtonNoPadding = styled(Button)`
  padding: 0;
`;

export const ScreenContainer = styled.div`
  padding: 3.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
